<div *ngFor="let xmlSection of iagPortalDetailsXmlSection">
  <div class="body-table">
    <app-prism-xml [xmlData]="xmlSection.xmlData"></app-prism-xml>
    <div *ngIf="xmlSection.tableSections">
      <app-table-section [tableSections]="xmlSection.tableSections"></app-table-section>
    </div>
  </div>
</div>
